import React from 'react';
import classnames from 'classnames';
import Event from './Event/Event';
import slugify from '../../util/slugify';
import {parseDate} from '../../../../assets/util';
import {FormattedDate, FormattedTime} from 'react-intl';
import PropTypes from 'prop-types';

import styles from './StreamEvent.module.css';
import {connect} from 'react-redux';

const DateSeparator = ({date}) => (
    <div className={styles.dateSeparator}>
        <FormattedDate value={parseDate(date)}/>
    </div>
);

const Author = ({author}) => {
    let authorName = author.name;
    const authorMark = author.mark;

    if (authorMark) {
        authorName += ' ' + authorMark;
    }

    return (
        <h4 className='media-heading'>
            {authorName}
        </h4>
    );
};

const EventTime = ({time}) => (
    <div className='media-right pl-2'>
        <small>
            <FormattedTime value={parseDate(time)}/>
        </small>
    </div>
);

const StreamEvent = ({event, author, authorChanged, dateChanged, self, isFirst, isFirstContent, attributes, thread}) => {
    const containerClass = classnames(
        {
            'event-author': (thread.author === event.author),
        }
    );
    const eventClass = classnames(
        'media',
        'event-' + (isFirstContent && event.type === 'message' ? 'workflow' : event.type),
        {
            'event-authored': authorChanged,
            'event-self': self,
            'event-author': (thread.author === event.author),
        },
        'event-author-mark-' + (slugify(author.mark || '')),
    );

    // If thread has no attributes, do not show whole row.
    if ('workflow' === event.type && isFirst &&
        !attributes.filter((attribute) => attribute.value).length) {
        return null;
    }

    return (
        <div className={containerClass}>
            {dateChanged
                ? <DateSeparator date={event.createdAt}/>
                : null
            }
            {authorChanged
                ? <Author author={author}/>
                : null
            }
            <div className={eventClass}>
                <Event isFirst={isFirstContent} attributes={attributes} event={event}/>
                <EventTime time={event.createdAt}/>
            </div>
        </div>
    );
};

StreamEvent.propTypes = {
    event: PropTypes.any.isRequired,
    authorChanged: PropTypes.bool.isRequired,
    dateChanged: PropTypes.bool.isRequired,
    self: PropTypes.bool.isRequired,
    isFirst: PropTypes.bool.isRequired,
    attributes: PropTypes.any,
};

export default connect(
    (state, props) => ({
        author: state.getIn(['participants', props.event.author]),
    }),
)(StreamEvent);
